<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('ITEM.EMAILS') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <emails-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="update">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import EmailsForm from '@/modules/forms/components/EmailsForm.vue';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'EmailsDialog',

  components: { EmailsForm },

  mixins: [errors],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: true,
      form: {}
    };
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    ...mapActions('form', ['updateFormApp']),
    valueWatchHandler(formProps) {
      if (!formProps.id) {
        return;
      }
      this.form = { ...formProps.form_emails, id: formProps.id };
    },

    cancel() {
      this.$emit('cancel');
    },

    update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.updateFormApp(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('updated', data.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
